import './SeatPicker/styles/index.css';
import { SeatPicker } from './SeatPicker/SeaPicker';
export default SeatPicker;



//////////////////
// WEBPACK FOOTER
// ./src/components/Seatmap/index.tsx
// module id = 518
// module chunks = 0